<template>
    <div class="webinar-exam-creator">
        <div class="section-header">Egzamin</div>
        <div v-for="(question, index) in questions" :key="index">
            <EditSection
                accent="apple"
                :errors="errors"
                :sections="question.section"
                ref="accountSections"
                section="accountSections"
            />
            <div class="exam-answers">
                <div
                    class="exam-answer-group"
                    v-for="(answer, aIndex) in question.answers"
                    :key="aIndex"
                >
                    <div class="exam-answer">
                        <div class="answer-key">{{ answer.key }}</div>
                        <div class="flex-row">
                            <div class="section-selector">
                                <input
                                    type="text"
                                    v-model="answer.value"
                                    :style="color"
                                />
                            </div>
                            <i
                                class="material-icons"
                                @click="removeAnswer(index, aIndex)"
                                >delete</i
                            >
                        </div>
                    </div>
                </div>
            </div>
            <ActionButton
                color="apple"
                label="Dodaj odpowiedź"
                materialIcon="add"
                @click="addAnswer(index)"
            />
            <ActionButton
                color="red"
                label="Usuń pytanie"
                materialIcon="delete"
                @click="removeQuestion(index)"
            />
        </div>
        <div style="display: flex; margin-top: 2rem;">
            <ActionButton
                label="Dodaj pytanie"
                materialIcon="add"
                @click="addQuestion"
            />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        errors: Object
    },
    data() {
        return {
            questions: [
                {
                    section: {
                        question: {
                            title: 'Pytanie',
                            value: '',
                            type: 'text-input',
                            key: 'question',
                            color: '#FFF',
                            size: 3
                        },
                        correct: {
                            title: 'Poprawna odpowiedź',
                            value: '',
                            type: 'text-input',
                            key: 'correct',
                            color: '#FFF',
                            size: 1
                        }
                    },
                    answers: []
                }
            ]
        }
    },
    methods: {
        removeQuestion(index) {
            this.questions.splice(index, 1)
        },
        addQuestion() {
            this.questions.push({
                section: {
                    question: {
                        title: 'Pytanie',
                        value: '',
                        type: 'text-input',
                        key: 'question',
                        color: '#FFF',
                        size: 3
                    },
                    correct: {
                        title: 'Poprawna odpowiedź',
                        value: '',
                        type: 'text-input',
                        key: 'correct',
                        color: '#FFF',
                        size: 1
                    }
                },
                answers: []
            })
            this.$nextTick(() => {
                if (this.$parent.$refs.content) {
                    this.$parent.$refs.content.scrollTop = 100000
                } else {
                    this.$emit('scroll')
                }
            })
        },
        getExam() {
            let isIvalid = true
            const values = this.questions.map(q => {
                const question = q.section.question.value
                const correct = q.section.correct.value
                const answers = q.answers
                if (!question || !correct || answers.length == 0) {
                    isIvalid = false
                }
                return {
                    question: question,
                    correct: correct,
                    answers: answers
                }
            })
            return isIvalid ? values : false
        },
        setQuestions(questions) {
            this.questions = questions.map(section => {
                return {
                    section: {
                        question: {
                            title: 'Pytanie',
                            value: section.question,
                            type: 'text-input',
                            key: 'question',
                            color: '#FFF',
                            size: 3
                        },
                        correct: {
                            title: 'Poprawna odpowiedź',
                            value: section.correct,
                            type: 'text-input',
                            key: 'correct',
                            color: '#FFF',
                            size: 1
                        }
                    },
                    answers: section.answers
                }
            })
        },
        removeAnswer(questionIndex, answerIndex) {
            this.questions[questionIndex].answers.splice(answerIndex, 1)
        },
        addAnswer(index) {
            if (this.questions[index].answers.length == 0) {
                this.questions[index].answers.push({ key: 'a', value: '' })
            } else {
                const currentKey = this.questions[index].answers[
                    this.questions[index].answers.length - 1
                ].key.charCodeAt(0)
                const nextKey = String.fromCharCode(currentKey + 1)
                this.questions[index].answers.push({ key: nextKey, value: '' })
                this.$nextTick(() => {
                    if (this.$parent.$refs.content) {
                        this.$parent.$refs.content.scrollTop = 100000
                    } else {
                        this.$emit('scroll')
                    }
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.exam-answer {
    margin-bottom: 1rem;
}
.answer-key {
    font-family: $input-family;
    text-transform: capitalize;
    padding: 0.6rem 0;
}
.section-header {
    padding: 0.6rem 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.4rem;
    color: $accent-apple;
    font-family: 'SofiaProSemiBold';
}
</style>
